module.exports = __webpack_public_path__ + "img/allgemeine-struktur.5e4729ee.png";